
export function useSlideTitle() {
  return 'Fertilizer Prices – Overview Current vs Year Ago';
}